module.exports = __webpack_public_path__ + "static/media/vis10.dca60c0a.jpeg";